import script from "./EORApprovedEmailsImport.vue?vue&type=script&setup=true&lang=js"
export * from "./EORApprovedEmailsImport.vue?vue&type=script&setup=true&lang=js"

import "./EORApprovedEmailsImport.vue?vue&type=style&index=0&id=10a10791&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a10791"]])

export default __exports__